/* unplugin-vue-components disabled */import { render } from "./KilaKilaAdminMenu.vue?vue&type=template&id=1aede40e&scoped=true"
import script from "./KilaKilaAdminMenu.vue?vue&type=script&lang=js"
export * from "./KilaKilaAdminMenu.vue?vue&type=script&lang=js"

import "./KilaKilaAdminMenu.vue?vue&type=style&index=0&id=1aede40e&lang=less&scoped=true"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aede40e"]])

export default __exports__